<mat-progress-bar
  [ngClass]="['weave-progress-bar', color]"
  class="weave-progress-bar"
  [mode]="mode"
  [value]="value">
</mat-progress-bar>
